require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-map');
module.exports = require('../modules/$.core').WeakMap;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/weak-map.js
 ** module id = 388
 ** module chunks = 0
 **/